import {Carousel} from '@mantine/carousel';
import {Box, Card, MantineProvider} from '@mantine/core';
import {type FC, useEffect, useState} from 'react';
import {MdAdsClick} from 'react-icons/md';
import {TOPIC_COMPANIES} from '../../../../core/entities/reportAnalytics/constants';
import {CommonLink} from '../../../../shared/components/CommonLink';

type Props = {
  companyName: string;
  DepartmentName: string;
  url: string;
};

export const TopicsCard: FC<Props> = ({companyName, DepartmentName, url}) => {
  return (
    <MantineProvider
      theme={{
        colors: {
          selection: ['EDB835'],
          intern: ['9FCE60'],
        },
      }}
    >
      <CommonLink href={url}>
        <Card
          shadow="xs"
          className="flex h-[86px] bg-white text-black-1  hover:bg-opacity-60 transition-all"
        >
          <Box className="w-full flex flex-col">
            <Box className="flex flex-col justify-between">
              <Box>
                <Box className="text-base font-bold line-clamp-1">
                  {companyName}
                </Box>
                <Box className="text-base line-clamp-1">{DepartmentName}</Box>
              </Box>
            </Box>
            <Box className="flex w-full justify-end text-xs">
              分析結果
              <MdAdsClick size={16} />
            </Box>
          </Box>
        </Card>
      </CommonLink>
    </MantineProvider>
  );
};

type TopicsCardsProps = {
  isPC: boolean;
  reportType: string;
};

export const TopicsCards: FC<TopicsCardsProps> = ({isPC, reportType}) => {
  const [companies, setCompanies] = useState(TOPIC_COMPANIES);

  useEffect(() => {
    const shuffledCompanies = [...TOPIC_COMPANIES]
      .filter((item) => item.reportType === reportType)
      .sort(() => Math.random() - 0.5);
    setCompanies(shuffledCompanies);
  }, [reportType]);

  return (
    <Carousel
      id="report-analytics-topics-cards"
      className="px-16 py-20 bg-black-5"
      align="start"
      slideSize="18%"
      slideGap="md"
      loop
      slidesToScroll={isPC ? 3 : 1}
      breakpoints={[
        {maxWidth: 'md', slideSize: '20%'},
        {maxWidth: 'xs', slideSize: '38%'},
      ]}
    >
      {companies.map((company) => (
        <Carousel.Slide key={company.companyId}>
          <TopicsCard
            companyName={company.companyName}
            DepartmentName={company.departmentName}
            url={`/report_analytics/result/${company.companyId}/${company.departmentId}?reportType=${reportType}`}
          />
        </Carousel.Slide>
      ))}
    </Carousel>
  );
};
